/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 43,
  image: "default-changelog-v2.png",
  title: "Manual Scaling Feature, FVM Deal Utils Package, Base Chain Integration, Platform Enhancements",
  shortDescription: "We have launched the closed alpha release of the Manual Scaling feature, introduced the FVM Deal Utils Package, made platform enhancements, and seamlessly integrated the Base Chain for streamlined payments with expanded token support",
  description: "We have launched the closed alpha release of the Manual Scaling feature, introduced the FVM Deal Utils Package, made platform enhancements, and seamlessly integrated the Base Chain for streamlined payments with expanded token support",
  date: "Aug 28th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## Manual Scaling Feature - Closed Alpha Release
We are pleased to announce the closed alpha release of our advanced Manual Scaling feature. This enhancement allows users to manually adjust various parameters of deployed instances, including:

- Number of running pods
- CPU allocation
- Memory utilization
- Ephemeral and persistent storage configuration

**Caution**: The Manual Scaling feature is currently in its closed alpha stage. Potential irregularities may lead to brief service downtimes. We recommend utilizing this feature exclusively in testing or development environments until its official release for optimal stability.

To maintain a systematic rollout and ensure an unparalleled user experience, activation of this feature necessitates whitelisting. If you're interested in obtaining alpha access, please [use this link](https://meetings.hubspot.com/prashant-maurya/scaling-demo) to schedule a call with our team.

For a comprehensive understanding of this feature, please refer to our [documentation](https://docs.spheron.network/compute/scaling/manual-scaling/).

## FVM Deal Utils Package

We are proud to introduce our newly published package: [@spheron/fvm-deal-utils](https://www.npmjs.com/package/@spheron/fvm-deal-utils). This utility facilitates the generation of essential metadata for storage deal creation on FVM. Detailed information regarding its utilization can be found in our [documentation](https://docs.spheron.network/sdk/fvm-deal-utils/).

We would like to extend special acknowledgment to one of our community members, [@ronykris](https://github.com/ronykris), for their significant contribution to the development of this package. Their dedication and expertise played a pivotal role in bringing this utility to fruition. For a detailed view of the contribution, refer to the PR: [https://github.com/spheronFdn/sdk/pull/140](https://argojiira.atlassian.net/wiki/spaces/SD/pages/361070593/Changelogs+for+2023-08-28#:~:text=https%3A//github.com/spheronFdn/sdk/pull/140).

As we continually strive to improve, we welcome and encourage open-source contributions to our SDK. Collaborations like these significantly enhance the developer experience and drive innovation.

## Platform Enhancements & Rectifications

- Enhanced Framework Suggestion Logic: Our refined logic enhances the simplicity of project configuration by providing improved framework suggestions.
- Optimized Cluster Instance Update Feedback: The latest update augments error feedback during instance modifications, providing users with clearer insights into potential failures.
- Provider Consistency Issue Resolved: An identified problem where the Git Provider unintentionally reverted to GitHub post-repository switching has been rectified, ensuring uniform deployment provider operations.

## Base Chain Integration for Streamlined Payments

We've seamlessly integrated the Base Chain to offer rapid, effortless, and secure payment transactions on Spheron.

**Expanded Token Support:** We now support **DAI**, **WETH** and **USDbC** tokens within the Base ecosystem, broadening transactional versatility.

The procedure for upgrading to the PRO plan remains consistent. Users should connect their wallets, choose the Base chain, and then select their preferred token for subscription payments.

Subscribers are encouraged to elevate their subscriptions to the PRO plan and avail additional benefits using the Base Chain.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
